<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="op_code,op_vendname"
      placeholder="输入单号、供应商进行查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/money/otherbillap/'+item.id"
      >
        <div class="weui-cell__bd">
          <p>{{item.op_vendname}}</p>
          <p class="list-item-muted">{{item.op_code}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.op_currency}}</p>
          <span
            class="list-item-status"
            :class="{'warning':item.op_status!='已审核'}"
          >{{item.op_status}}</span>
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{items.length}}单</label>
      <!-- <em class="list-footer__value" v-format="'¥#,##0.00'">{{getTotal('os_amount')}}</em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/money/otherbillap/list",
      filters: [
        {
          type: "date",
          name: "op_date"
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部"
            },
            {
              value: 1,
              label: "待审核",
              condition: "op_statuscode='UNAUDITED'"
            },
            {
              value: 2,
              label: "已审核",
              condition: "op_statuscode='AUDITED'"
            }
          ]
        }
      ]
    };
  }
};
</script>